'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiSelections = function ApiSelections(Restangular, ApiBaseResponseService) {
    _classCallCheck(this, ApiSelections);

    return {
        /**
         * Get all selections
         * @return {Object}
         */

        getSelectionsFiltered: function getSelectionsFiltered(filterObject) {
            return Restangular.one('selections').get(filterObject).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Get all selections
         * @return {Object}
         */
        getSelections: function getSelections() {
            return Restangular.one('selections').get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
          Gets the selections that are purchasd by members of the team the user belongs to.
        */
        getPurchasedTeamSelections: function getPurchasedTeamSelections() {
            return Restangular.one('selections/teamPurchased').get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * get the selection details
         * @param  {integer} selectionId
         * @return {Object}  selectionDetail object of the id provided as argumnent
         */
        getSelection: function getSelection(selectionId) {
            return Restangular.one('selections', selectionId).get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         Get the selections with an existing license for the user
         */
        getSelectionsMinimal: function getSelectionsMinimal() {
            return Restangular.one('selections/minimal').get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * get the children of a selection
         * @param  {integer} selectionId
         * @return {Object}  selectionDetail object of the id provided as argumnent
         */
        getSelectionChildren: function getSelectionChildren(selectionId) {
            return Restangular.one('selections', selectionId).one('children').get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        getSelectionsOfUser: function getSelectionsOfUser(userId) {
            return Restangular.one('selections').one('user', userId).get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * post payment information
         * @return {Object}
         */
        purchaseByCC: function purchaseByCC(payment) {

            for (var i = 0; i < payment.selectionsToPurchase.length; i++) {
                delete payment.selectionsToPurchase[i].cost;
                delete payment.selectionsToPurchase[i].selectionName;
                delete payment.selectionsToPurchase[i].subtitle;
                delete payment.selectionsToPurchase[i].icon;
            }

            var purchaseLicenceModel = {
                'stripeOneTimeToken': payment.token,
                'selectionsToPurchase': payment.selectionsToPurchase
            };

            return Restangular.all('licenses').all('purchaseByCC').post(purchaseLicenceModel).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * post payment information
         * @return {Object}
         */
        purchaseByInvoice: function purchaseByInvoice(selectionsToPurchase) {
            return Restangular.all('licenses').all('purchaseByInvoice').post({ selectionsToPurchase: selectionsToPurchase }).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * post user Ids
         * @return {Object}
         */
        removeLicenses: function removeLicenses(userIds, licenseId) {
            return Restangular.one('licenses', licenseId).all('assignedUsers').remove(userIds).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * post user Ids
         * @return {Object}
         */
        assignLicenses: function assignLicenses(userIds, licenseId) {
            return Restangular.one('licenses', licenseId).all('assignedUsers').post(userIds).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        verifyPrices: function verifyPrices(licenses) {
            licenses.forEach(function (item) {
                delete item.cost;
                delete item.selectionName;
                delete item.subtitle;
                delete item.icon;
            });
            return Restangular.all('licenses').all('verifyPrices').post(licenses).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        }
    };
};

ApiSelections.inject = ['Restangular', 'ApiBaseResponseService'];

exports.default = ApiSelections;


/** WEBPACK FOOTER **
 ** ./src/app/services/apiSelections.js
 **/